import React from 'react';

function DarkFaqExercises(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43216'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43216)'>
        <path
          d='M32.124 12.4707C32.9659 11.5874 34.3457 11.5872 35.1875 12.4707L38.6689 16.124C39.4979 16.9937 39.4974 18.3985 38.6689 19.2686L21.3506 37.4434H38.8857C39.4947 37.4436 39.876 37.986 39.876 38.5059C39.8757 39.0256 39.4945 39.5681 38.8857 39.5684H13.9902C13.3812 39.5684 13.0002 39.0257 13 38.5059C13 38.4306 13.0079 38.3548 13.0234 38.2803C12.9938 38.1199 12.9926 37.9537 13.0225 37.79L14.0908 31.9375C14.1706 31.5015 14.3721 31.0999 14.6758 30.7812L32.124 12.4707ZM38.8857 39.0674H15.7998L15.7949 39.0684H38.8857C38.9175 39.0683 38.9484 39.0633 38.9785 39.0566C38.9484 39.0633 38.9175 39.0674 38.8857 39.0674ZM38.3066 18.9248L20.8584 37.2354H20.8594L38.3076 18.9238L38.3066 18.9248ZM16.373 32.4238L15.5986 36.665L19.5938 35.8613L20.6504 34.752L17.4023 31.3428L16.373 32.4238ZM19.0342 29.6309L22.2822 33.04L33.1484 21.6377L29.9004 18.2285L19.0342 29.6309ZM30.8408 16.5166L34.7803 20.6504L30.8418 16.5166L33.4268 13.8027L30.8408 16.5166ZM31.5312 16.5156L34.7803 19.9238L36.9033 17.6963L33.6553 14.2871L31.5312 16.5156Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqExercises.displayName = 'DarkFaqExercises';

export default DarkFaqExercises;
